import './styles/tailwind.css';
import { mountApp } from './app/components/App';
import { registerSW } from 'virtual:pwa-register';

// Update SW as soon as a new version is available
registerSW({ immediate: true });

const root = document.getElementById('app')!;
mountApp(root).catch(err => {
  console.error('Failed to mount app:', err);
  root.innerHTML = `
    <div class="min-h-screen flex items-center justify-center p-6">
      <div class="max-w-md text-center space-y-2">
        <h1 class="text-2xl font-semibold text-rose-600">Couldn't start Budget Tracker v2</h1>
        <p class="text-slate-600 dark:text-slate-300 text-sm">${(err as Error).message}</p>
        <p class="text-xs text-slate-400">Your v1 data is untouched. Visit <a href="/v1/" class="underline">/v1/</a> to use the legacy app.</p>
      </div>
    </div>
  `;
});
